import { Component, createRef } from 'react';

/**
 * The hamburger menu a settings card hangs next to its title.
 *
 * Actions that throw work away (re-profiling, deleting) live here rather than as buttons in the
 * header, so the card's only one-click action stays the safe one. The list overlays the card
 * body, so it closes on an outside click and on Escape.
 */
class CardMenu extends Component {
    constructor() {
        super();

        this.rootRef = createRef();
        this.onToggle = this.onToggle.bind(this);
        this.onDocumentMouseDown = this.onDocumentMouseDown.bind(this);
        this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);

        this.state = { isOpen: false };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.onDocumentMouseDown);
        document.addEventListener('keydown', this.onDocumentKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onDocumentMouseDown);
        document.removeEventListener('keydown', this.onDocumentKeyDown);
    }

    onDocumentMouseDown(e) {
        if (this.state.isOpen && !this.rootRef.current?.contains(e.target)) {
            this.setState({ isOpen: false });
        }
    }

    onDocumentKeyDown(e) {
        if (e.key === 'Escape') {
            this.setState({ isOpen: false });
        }
    }

    onToggle() {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    }

    render() {
        const { items, label, disabled } = this.props;

        return (
            <div className="settings-menu" ref={this.rootRef}>
                <button
                    type="button"
                    className="settings-menu-toggle"
                    title={label}
                    aria-label={label}
                    aria-expanded={this.state.isOpen}
                    disabled={disabled}
                    onClick={this.onToggle}
                >
                    <i className="icon-menu" />
                </button>
                {this.state.isOpen && (
                    <div className="settings-menu-list">
                        {items.map((item) => (
                            <button
                                type="button"
                                key={item.key}
                                className={`settings-menu-item ${item.danger ? 'is-danger' : ''}`}
                                disabled={item.disabled}
                                onClick={() => {
                                    this.setState({ isOpen: false });
                                    item.onClick();
                                }}
                            >
                                {!!item.icon && <i className={item.icon} />}
                                {item.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default CardMenu;
